// extracted by mini-css-extract-plugin
module.exports = {"productModule":"ProductModule_productModule__CcJmt"};